import { useCallback, useState } from 'react'
import { Button } from 'antd'
import { SiteAddressSearchModal } from './SiteAddressSearchModal'

export type SelectedAddressResult = {
  entered: string
  known: string
  coordinates: { lat: number; lon: number }
}

export type CurrentValuesResult = {
  given: string
  known: string
}

export function SiteAddressSearchModalLink({
  currentValue,
  projectCountry,
  onSubmit
}: {
  currentValue: string
  projectCountry: string
  getGivenIsDirty: () => boolean
  onSubmit: (result: SelectedAddressResult) => void
}) {
  const [siteAddressSearchModalOpen, setSiteAddressSearchModalOpen] =
    useState<boolean>(false)

  const handleSubmit = useCallback(
    (result: SelectedAddressResult) => {
      onSubmit(result)
      setSiteAddressSearchModalOpen(false)
    },
    [onSubmit]
  )

  return (
    <>
      <Button
        type="link"
        size="small"
        tabIndex={-1}
        onClick={() => setSiteAddressSearchModalOpen(true)}
        aria-label={`Search for address`}
        style={{ textDecoration: 'underline' }}
      >
        Search for address
      </Button>

      {siteAddressSearchModalOpen && (
        <SiteAddressSearchModal
          currentValue={currentValue}
          projectCountry={projectCountry}
          isOpen={true}
          onCancel={() => setSiteAddressSearchModalOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  )
}
